import { createSlice } from '@reduxjs/toolkit';

export const accountSlice = createSlice({
  name: 'account',
  initialState: {
    is_aryeh_analyst: false,
    account_list: [],
    default_account: {},
    account_details_list: [],
    accounts_list: [],
    accounts_per_user_list: [],
  },
  reducers: {
    setAccounts: (state, action) => {
      state.account_list = action.payload
    },
    setDefaultAccount: (state, action) => {
      state.default_account = action.payload
    },
    setAccountsDetails: (state, action) => {
      state.account_details_list = action.payload
    },
    setAccountsList: (state, action) => {
      state.accounts_list = action.payload
    },
    setAccountsByUserList: (state, action) => {
      state.accounts_per_user_list = action.payload
    },
    setIsAryehAnalyst: (state, action) => {
      state.is_aryeh_analyst = action.payload
    },
  },
})
export const { setAccounts, setDefaultAccount, setAccountsDetails, setAccountsList, 
  setAccountsByUserList, setIsAryehAnalyst } = accountSlice.actions
export default accountSlice.reducer